import { CellProps, Column, HeaderProps } from "react-table";
import { formatDateToDDMMYYYY, formatMoney } from "../../utils/FormatUtils";
import {VARIABLE_STRING} from "../../utils/Constant";
import {renderThumbnailCell} from "../../phan-he-thong-ke/constants/ColumnsThongKe";

const SITE = process.env.REACT_APP_SITE;

export const getColumns = (labelProduct?: string): Column<any>[] => {
	const label = labelProduct ?? 'Thuốc';
	const COLUMNS: Column<any>[] = [
		{
			Header: () => {
				return (
					<div className="spaces  text-center min-w-80">{`Mã ${label}`}</div>
				)
			},
			accessor: 'code',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-80">{(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-240 text-center">{`Tên ${label}`}</div>
				)
			},
			accessor: 'name',
			width: 200,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-240">{(value)}</div>
				)
			},
		},
		{
			id: VARIABLE_STRING.THUMBNAIL,
			Header: (props: any) => renderThumbnailCell(props, "header"),
			Cell: (props: any) => renderThumbnailCell(props, "body"),
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Số lô</div>
				)
			},
			accessor: 'consignment',
			width: 200,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-80">{(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-90 text-center">Hàm Lượng</div>
				)
			},
			accessor: 'dosage',
			width: 150,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-90">{(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-300 text-center">Hoạt Chất</div>
				)
			},
			accessor: 'actIngName',
			width: 150,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-300">{(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Đơn vị</div>
				)
			},
			accessor: 'unitofMeasureName',
			width: 120,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-80">{(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Khả dụng</div>
				)
			},
			accessor: 'availableQuantity',
			width: 80,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{value}</div>
				)
			},
		},
		...SITE !== 'RHM' ? [{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Đơn giá</div>
				)
			},
			accessor: 'sellingPrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Giá bán</div>
				)
			},
			accessor: 'salePrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Giá BHYT</div>
				)
			},
			accessor: 'bhytPrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Giá VP</div>
				)
			},
			accessor: 'hospitalPrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Giá dịch vụ</div>
				)
			},
			accessor: 'servicePrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		}] : [],
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Loại Thuốc</div>
				)
			},
			accessor: 'drugTypeName',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-80">{(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">HSD</div>
				)
			},
			accessor: 'expiryDate',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-center spaces min-w-80">{formatDateToDDMMYYYY(value)}</div>
				)
			},
		},
	];

	return COLUMNS;
}
export const getColumnsNhapKho = (labelProduct?: string): Column<any>[] => {
	const label = labelProduct ?? 'Thuốc';
	const COLUMNS_NHAP_KHO : Column<any>[] = [
		{
			Header: () => {
				return (
					<div className="spaces text-center min-w-80">{`Mã ${label}`}</div>
				)
			},
			accessor: 'code',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-80">{(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-240 text-center">{`Tên ${label}`}</div>
				)
			},
			accessor: 'name',
			width: 200,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-240">{(value)}</div>
				)
			},
		},
		{
			id: VARIABLE_STRING.THUMBNAIL,
			Header: (props: any) => renderThumbnailCell(props, "header"),
			Cell: (props: any) => renderThumbnailCell(props, "body"),
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Số lô</div>
				)
			},
			accessor: 'consignment',
			width: 200,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-80">{(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Đơn vị</div>
				)
			},
			accessor: 'unitofMeasureName',
			width: 120,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="spaces min-w-80">{(value)}</div>
				)
			},
		},
		...SITE !== 'RHM' ? [{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Đơn giá</div>
				)
			},
			accessor: 'sellingPrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Giá BHYT</div>
				)
			},
			accessor: 'bhytPrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Giá VP</div>
				)
			},
			accessor: 'hospitalPrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">Giá dịch vụ</div>
				)
			},
			accessor: 'servicePrice',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-end spaces min-w-80">{formatMoney(value)}</div>
				)
			},
		}] : [],
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">QĐ thầu</div>
				)
			},
			accessor: 'serialNumber',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className=" spaces min-w-80">{value}</div>
				)
			},
		},
		{
			Header: () => {
				return (
					<div className="spaces min-w-80 text-center">HSD</div>
				)
			},
			accessor: 'expiryDate',
			width: 100,
			Cell: ({ value }: CellProps<any>) => {
				return (
					<div className="text-center spaces min-w-80">{formatDateToDDMMYYYY(value)}</div>
				)
			},
		},
	];
	return COLUMNS_NHAP_KHO
}
